import { render, staticRenderFns } from "./Personalization.vue?vue&type=template&id=6b9a915a&scoped=true&"
import script from "./Personalization.vue?vue&type=script&lang=js&"
export * from "./Personalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a915a",
  null
  
)

export default component.exports